import * as React from 'react'
import { Spacer } from '../../../common/src/components/core'
import styled from '../../../common/src/components/styled'
import { Colors, Fonts } from '../../../common/src/constants'
import { dateNoYearFmtLong, timeFmt } from '../../../common/src/date'

const TimeDateRoot = styled.div({
  color: Colors.silver,
})

const TimeContatiner = styled.div({
  fontSize: 64,
  fontFamily: Fonts.sansHeader,
  fontWeight: 'lighter',
})

const DateContainer = styled.div({
  fontSize: 16,
  fontFamily: Fonts.sansBody,
})

interface TimeDateProps {
  now: Date
}

const TimeDate = (props: TimeDateProps) => {
  const { now } = props
  return (
    <TimeDateRoot>
      <TimeContatiner>{timeFmt(now)}</TimeContatiner>
      <Spacer height={8} />
      <DateContainer>{dateNoYearFmtLong(now)}</DateContainer>
    </TimeDateRoot>
  )
}

export default TimeDate
